

import React from 'react'
import { useState, useEffect } from 'react';
import './index.scss'
import ComBtn from '@/components/comBtn';
import classnames from 'classnames';
export default React.memo(function ({
    info,
    handleBtn,
    toPast
}) {
    let [btn, setBtn] = useState(null);
    let [rate, setRate] = useState(null);
    useEffect(() => {
        switch(info.realStatus) {
            case 'ac1':
            case 'ac2':
            case 'fr1':
            case 'fr2': 
            case 'rw1': 
            case 'ou1':
            case 'ou2':
            case 'ou4':
                setRate(<div className='list-item-rate'>已完成{info.rate}%</div>);
                break;
            case 'rw2':
                setRate(<div className='list-item-rate list-item-red'>{info.rewardEndTimeText}</div>)
                break;
        }
    }, [info.realStatus])
    return (
        <div className={classnames('list-item', info.taskCycle === 3?'list-item-clc': '')}>
            <img src={info.iconUrl}/>
            <div className='list-font'>
                <div className='list-font-f1'>
                    <div>领{info.rewardName}</div>
                    { info.taskCycle === 3?<div>每月任务</div>: ''}
                </div>
                <div className='list-font-f2'>{info.reachTitle}</div>
                { info.taskCycle === 3?
                    <div 
                        className='list-task-time' 
                        onClick={toPast.bind(null, info.parentTaskCode)}
                        clstag = 'rwlist|wqrk'
                        data-qidian-ext={JSON.stringify({missionid: info.taskCode})} 
                        >
                        <div>{info.showTime}</div>
                        <div>往期任务</div>
                    </div>: null
                }
            </div>
            <div className='list-item-right'>
                <ComBtn handleBtn={handleBtn.bind(null, info)} info={info}></ComBtn>
                { rate }
            </div>
        </div>
    )
})


